module.exports = __webpack_public_path__ + "img/delete.029a0670.svg";